/**
 * ============================================================
 * FILE: assets/jersey-personalizer.js
 * ============================================================
 * Self-contained. No dependencies. Runs after DOMContentLoaded.
 * ============================================================
 */

(function () {
  'use strict';

  /* ── Wait for DOM ── */
  function init() {
    var wrap    = document.getElementById('jp-wrap');
    if (!wrap) return; /* snippet not on page */

    /* ── Element refs ── */
    var trigger     = document.getElementById('jp-trigger');
    var backdrop    = document.getElementById('jp-backdrop');
    var closeBtn    = document.getElementById('jp-modal-close');
    var cancelBtn   = document.getElementById('jp-cancel');
    var saveBtn     = document.getElementById('jp-save');
    var savedBadge  = document.getElementById('jp-saved-badge');
    var savedName   = document.getElementById('jp-saved-name');
    var savedNumber = document.getElementById('jp-saved-number');
    var savedEdit   = document.getElementById('jp-saved-edit');
    var feeNote     = document.getElementById('jp-fee-note');
    var charHint    = document.getElementById('jp-char-hint');

    /* Inputs */
    var inpName   = document.getElementById('jp-inp-name');
    var inpNumber = document.getElementById('jp-inp-number');
    var playerSel = document.getElementById('jp-player-sel');

    /* Hidden property inputs */
    var propName   = document.getElementById('jp-prop-name');
    var propNumber = document.getElementById('jp-prop-number');
    var propType   = document.getElementById('jp-prop-type');

    /* Mode & view tabs */
    var modeTabs  = document.querySelectorAll('.jp-mode-tab');
    var panels    = document.querySelectorAll('.jp-panel');
    var viewTabs  = document.querySelectorAll('.jp-view-tab');

    /* SVGs */
    var svgBack  = document.getElementById('jp-svg-back');
    var svgFront = document.getElementById('jp-svg-front');

    /* SVG text nodes */
    var backName    = document.getElementById('jp-back-name');
    var backNumber  = document.getElementById('jp-back-number');
    var frontNumber = document.getElementById('jp-front-number');

    /* State */
    var currentMode = 'custom';
    var currentView = 'back';
    var lastFocused = null;

    /* ── Read jersey colors from data attrs (set by Liquid) ── */
    var jerseyColor  = wrap.getAttribute('data-jersey-color')  || '#C8102E';
    var sleeveColor  = wrap.getAttribute('data-sleeve-color')  || '#1a1a1a';
    var numberColor  = wrap.getAttribute('data-number-color')  || '#c8a96e';

    /* ── Open / close ── */
    function openModal() {
      lastFocused = document.activeElement;
      backdrop.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('jp-modal-open');
      /* Focus first focusable inside modal */
      setTimeout(function () {
        var first = backdrop.querySelector('button, input, select');
        if (first) first.focus();
      }, 50);
    }

    function closeModal() {
      backdrop.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('jp-modal-open');
      if (lastFocused) lastFocused.focus();
    }

    /* ── Mode switching ── */
    function setMode(mode) {
      currentMode = mode;
      modeTabs.forEach(function (btn) {
        var active = btn.getAttribute('data-mode') === mode;
        btn.classList.toggle('jp-mode-tab--active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      var customPanel = document.getElementById('jp-panel-custom');
      var playerPanel = document.getElementById('jp-panel-player');
      if (mode === 'custom') {
        customPanel.classList.add('jp-panel--active');
        customPanel.removeAttribute('hidden');
        playerPanel.classList.remove('jp-panel--active');
        playerPanel.setAttribute('hidden', '');
      } else {
        playerPanel.classList.add('jp-panel--active');
        playerPanel.removeAttribute('hidden');
        customPanel.classList.remove('jp-panel--active');
        customPanel.setAttribute('hidden', '');
      }
      liveUpdate();
    }

    /* ── View switching (back / front) ── */
    function setView(view) {
      currentView = view;
      viewTabs.forEach(function (btn) {
        var active = btn.getAttribute('data-view') === view;
        btn.classList.toggle('jp-view-tab--active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (view === 'back') {
        svgBack.removeAttribute('hidden');
        svgFront.setAttribute('hidden', '');
      } else {
        svgFront.removeAttribute('hidden');
        svgBack.setAttribute('hidden', '');
      }
    }

    /* ── Live preview update ── */
    function liveUpdate() {
      var name   = '';
      var number = '';

      if (currentMode === 'custom') {
        name   = (inpName.value   || '').toUpperCase().trim();
        number = (inpNumber.value || '').trim();
        /* Update char counter */
        if (charHint) charHint.textContent = name.length + ' / 14 characters · Number 1–99';
      } else {
        var val = playerSel ? playerSel.value : '';
        if (val) {
          var parts = val.split('|');
          number = parts[0] || '';
          name   = parts[1] || '';
        }
      }

      /* Back name */
      if (backName) {
        if (name) {
          backName.textContent = name;
          backName.setAttribute('opacity', '1');
          /* Auto-scale font size to fit */
          var fs = name.length > 11 ? '13' : name.length > 8 ? '16' : '20';
          backName.setAttribute('font-size', fs);
        } else {
          backName.setAttribute('opacity', '0');
        }
      }

      /* Back + front number */
      var n = parseInt(number, 10);
      var validNum = number !== '' && n >= 1 && n <= 99;
      if (backNumber) {
        backNumber.textContent = validNum ? String(n) : '';
        backNumber.setAttribute('opacity', validNum ? '1' : '0');
      }
      if (frontNumber) {
        frontNumber.textContent = validNum ? String(n) : '';
        frontNumber.setAttribute('opacity', validNum ? '0.92' : '0');
      }

      /* Fee note */
      if (feeNote) {
        if (name || validNum) {
          feeNote.removeAttribute('hidden');
        } else {
          feeNote.setAttribute('hidden', '');
        }
      }
    }

    /* ── Save ── */
    function savePersonalisation() {
      var name   = '';
      var number = '';
      var type   = '';

      if (currentMode === 'custom') {
        name   = (inpName.value   || '').toUpperCase().trim();
        number = (inpNumber.value || '').trim();
        type   = 'Custom';
      } else {
        var val = playerSel ? playerSel.value : '';
        if (val) {
          var parts = val.split('|');
          number = parts[0] || '';
          name   = parts[1] || '';
        }
        type = 'Favourite Player';
      }

      /* Write hidden Shopify property inputs */
      if (propName)   propName.value   = name;
      if (propNumber) propNumber.value = number;
      if (propType)   propType.value   = (name || number) ? type : '';

      /* Show / update saved badge */
      if (name || number) {
        if (savedName)   savedName.textContent   = name;
        if (savedNumber) savedNumber.textContent = number ? '#' + number : '';
        var sep = backdrop.querySelector('.jp-saved-sep');
        if (sep) sep.style.display = (name && number) ? '' : 'none';
        if (savedBadge) savedBadge.removeAttribute('hidden');
      } else {
        if (savedBadge) savedBadge.setAttribute('hidden', '');
      }

      closeModal();
    }

    /* ── Event listeners ── */
    if (trigger)   trigger.addEventListener('click', openModal);
    if (savedEdit) savedEdit.addEventListener('click', openModal);
    if (closeBtn)  closeBtn.addEventListener('click', closeModal);
    if (cancelBtn) cancelBtn.addEventListener('click', closeModal);
    if (saveBtn)   saveBtn.addEventListener('click', savePersonalisation);

    /* Close on backdrop click */
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) closeModal();
    });

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') &&
          backdrop.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    /* Focus trap inside modal */
    backdrop.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = backdrop.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    });

    /* Mode tabs */
    modeTabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMode(btn.getAttribute('data-mode'));
      });
    });

    /* View tabs */
    viewTabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.getAttribute('data-view'));
      });
    });

    /* Live update on input */
    if (inpName) {
      inpName.addEventListener('input', liveUpdate);
    }
    if (inpNumber) {
      inpNumber.addEventListener('input', function () {
        /* Clamp to 1-99 */
        var v = parseInt(this.value, 10);
        if (this.value !== '' && (v < 1 || v > 99 || isNaN(v))) {
          this.value = isNaN(v) ? '' : Math.min(99, Math.max(1, v));
        }
        liveUpdate();
      });
    }
    if (playerSel) {
      playerSel.addEventListener('change', liveUpdate);
    }
  }

  /* ── Bootstrap ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
